import { useQuery } from '@tanstack/react-query';
import React from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import { useTranslation } from 'react-i18next';
import { MdRefresh } from 'react-icons/md';

import LoadingImage from '../../components/general/LoadingImage';
import { transactionService } from '../../services';
import SubscriptionDetailView from './SubscriptionDetailView';
import SwitchToStripeSubscriptionSpan from './SwitchToStripeSubscriptionSpan';

const SubscriptionsTable: React.FC = () => {
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useQuery(
    ['getMembershipDetails'],
    transactionService.getMembershipDetails
  );

  const hasActiveSubscriptions = (data?.subscriptions || []).some(
    subscription => subscription.status.toUpperCase() === 'ACTIVE'
  );
  const showSwitchToStripeButton =
    data?.info &&
    (data.info.membership_source === 'manual' || !hasActiveSubscriptions);

  return (
    <Card>
      <Card.Header>
        {t('Subscriptions')} <small>({t('may-be-delayed')})</small>{' '}
        <MdRefresh style={{ cursor: 'pointer' }} onClick={() => refetch()} />
      </Card.Header>
      <Card.Body>
        <LoadingImage displayAsBlock={true} loading={isFetching} />
        {data && (
          <div>
            {showSwitchToStripeButton && (
              <SwitchToStripeSubscriptionSpan info={data.info} />
            )}
            <ListGroup>
              {data.subscriptions.map(subscription => (
                <ListGroup.Item key={subscription.subscription_id}>
                  <SubscriptionDetailView
                    subscription={subscription}
                    onCancelled={() => refetch()}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
            {data.subscriptions?.length === 0 && t('cannot-find-subscription')}{' '}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SubscriptionsTable;
